import { SSOApiDatasource } from "@/shared/data/datasource/sso-api-datasource";
import { makeAuthorizeHttpClientDecorator } from "../decorators/authorazed-http-client-decorator-factory";
export var makeSSOApiDatasource = function () {
    return new SSOApiDatasource(makeAuthorizeHttpClientDecorator());
};
